export default "__VITE_ASSET__2aba9037__"